export var RetailerUserNotificationGroup;
(function (RetailerUserNotificationGroup) {
    RetailerUserNotificationGroup["RETAILER_USER_NOTIFICATION_GROUP_UNKNOWN"] = "RETAILER_USER_NOTIFICATION_GROUP_UNKNOWN";
    RetailerUserNotificationGroup["TEAM_COMMUNICATION"] = "TEAM_COMMUNICATION";
    RetailerUserNotificationGroup["R2B_NOTIFICATION"] = "R2B_NOTIFICATION";
    RetailerUserNotificationGroup["TEAM_UPDATES_NOTIFICATION"] = "TEAM_UPDATES_NOTIFICATION";
    RetailerUserNotificationGroup["IDV_MESSAGES_NOTIFICATION"] = "IDV_MESSAGES_NOTIFICATION";
    RetailerUserNotificationGroup["POS_SYNC_ISSUE_NOTIFICATION"] = "POS_SYNC_ISSUE_NOTIFICATION";
    RetailerUserNotificationGroup["NET_60_APPLICATION_NOTIFICATION"] = "NET_60_APPLICATION_NOTIFICATION";
    RetailerUserNotificationGroup["INSIDER_MEMBERSHIP_PAYMENT_NOTIFICATION"] = "INSIDER_MEMBERSHIP_PAYMENT_NOTIFICATION";
    RetailerUserNotificationGroup["OPEN_WITH_FAIRE_NOTIFICATION"] = "OPEN_WITH_FAIRE_NOTIFICATION";
    RetailerUserNotificationGroup["ORDER_ISSUES_NOTIFICATION"] = "ORDER_ISSUES_NOTIFICATION";
    RetailerUserNotificationGroup["PAYMENT_NOTIFICATION"] = "PAYMENT_NOTIFICATION";
})(RetailerUserNotificationGroup || (RetailerUserNotificationGroup = {}));
